// Popover

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import Overlay from 'react-overlays/lib/Overlay'
import _ from 'lodash'

const PopoverInnerStyle = {
  color: '#666',
  backgroundColor: '#fff',
  boxShadow: '0px 3px 30px 0px rgba(0, 0, 0, 0.22)'
}

const PopoverArrowStyle = {
  position: 'absolute',
  width: 0,
  height: 0,
  borderRightColor: 'transparent',
  borderLeftColor: 'transparent',
  borderTopColor: 'transparent',
  borderBottomColor: 'transparent',
  borderStyle: 'solid',
  top: 0
}

const PlacementStyles = {
  left: {
    tooltip: { marginLeft: -3, padding: '0 5px' },
    arrow: {
      right: 0,
      marginTop: -5,
      borderWidth: '5px 0 5px 5px',
      borderLeftColor: '#fff'
    }
  },
  right: {
    tooltip: { marginRight: 3, padding: '0 5px' },
    arrow: {
      left: 0,
      marginTop: -5,
      borderWidth: '5px 5px 5px 0',
      borderRightColor: '#fff'
    }
  },
  top: {
    tooltip: { marginTop: -3, padding: '5px 0' },
    arrow: {
      bottom: 0,
      marginLeft: -5,
      borderWidth: '5px 5px 0',
      borderTopColor: '#fff'
    }
  },
  bottom: {
    tooltip: { marginBottom: 3, padding: '5px 0' },
    arrow: {
      top: 0,
      marginLeft: -5,
      borderWidth: '0 5px 5px',
      borderBottomColor: '#fff'
    }
  }
}

class PopoverContent extends Component {
  static get propTypes () {
    return {
      style: PropTypes.object,
      innerStyle: PropTypes.object,
      outerStyle: PropTypes.object,
      children: PropTypes.object,
      className: PropTypes.string,
      placement: PropTypes.any,
      arrowOffsetLeft: PropTypes.any,
      arrowOffsetTop: PropTypes.any,
      arrowClass: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      style: null,
      innerStyle: null,
      outerStyle: null,
      children: null,
      className: '',
      placement: null,
      arrowOffsetLeft: null,
      arrowOffsetTop: 0,
      arrowClass: ''
    }
  }

  shouldComponentUpdate (nextProps, _nextState) {
    const {
      style,
      innerStyle,
      outerStyle,
      children,
      className,
      placement,
      arrowOffsetLeft,
      arrowOffsetTop,
      arrowClass
    } = this.props
    if (
      !_.isEqual(style, nextProps.style) ||
      !_.isEqual(innerStyle, nextProps.innerStyle) ||
      !_.isEqual(outerStyle, nextProps.outerStyle) ||
      !_.isEqual(children, nextProps.children) ||
      className !== nextProps.className ||
      placement !== nextProps.placement ||
      arrowOffsetLeft !== nextProps.arrowOffsetLeft ||
      arrowOffsetTop !== nextProps.arrowOffsetTop ||
      arrowClass !== nextProps.arrowClass
    ) {
      return true
    }
    return false
  }

  render () {
    const placementStyle = PlacementStyles[this.props.placement]

    const {
      style,
      innerStyle,
      outerStyle,
      arrowOffsetLeft: left = placementStyle && placementStyle.arrow
        ? placementStyle.arrow.left
        : 0,
      arrowOffsetTop: top = placementStyle && placementStyle.arrow
        ? placementStyle.arrow.top
        : 0,
      children,
      className,
      arrowClass
    } = this.props

    return (
      <div
        className={`common-popover${className ? ' ' + className : ''}`}
        style={{ ...placementStyle.tooltip, ...style, ...outerStyle }}
      >
        <div
          className={arrowClass}
          style={{ ...PopoverArrowStyle, ...placementStyle.arrow, left, top }}
        />
        <div
          className='popoverbody'
          style={{ ...PopoverInnerStyle, ...innerStyle }}
        >
          {children}
        </div>
      </div>
    )
  }
}

/* const PopoverContent = props => {
  const placementStyle = PlacementStyles[props.placement];

  const {
    style,
    innerStyle,
    arrowOffsetLeft: left = placementStyle.arrow.left,
    arrowOffsetTop: top = placementStyle.arrow.top,
    children,
    className
  } = props;

  return (
    <div className={`common-popover${className ? ' ' + className : ''}`} style={{ ...placementStyle.tooltip, ...style }}>
      <div style={{ ...PopoverArrowStyle, ...placementStyle.arrow, left, top }} />
      <div style={{ ...PopoverInnerStyle, ...innerStyle }}>
        {children}
      </div>
    </div>
  );
};

const Popover = props => (
  <Overlay
    show={props.show}
    onHide={props.onHide}
    placement={props.placement}
    container={props.container}
    target={p => ReactDOM.findDOMNode(props.target)}
    rootClose={props.hideWithOutsideClick || true}
  >
    <PopoverContent innerStyle={props.style} style={props.containerStyle}
      className={props.className}>
      {props.children}
    </PopoverContent>
  </Overlay>
); */

class Popover extends PopoverContent {
  static get propTypes () {
    return {
      show: PropTypes.bool,
      onHide: PropTypes.func,
      container: PropTypes.any,
      placement: PropTypes.any,
      hideWithOutsideClick: PropTypes.bool,
      target: PropTypes.object
    }
  }

  static get defaultProps () {
    return {
      show: false,
      onHide: null,
      container: null,
      placement: null,
      hideWithOutsideClick: null,
      target: null
    }
  }

  render () {
    return (
      <Overlay
        show={this.props.show}
        onHide={this.props.onHide}
        placement={this.props.placement}
        container={this.props.container}
        target={_p => ReactDOM.findDOMNode(this.props.target)}
        rootClose={this.props.hideWithOutsideClick || true}
      >
        <PopoverContent
          innerStyle={this.props.style}
          style={this.props.containerStyle}
          outerStyle={this.props.outerStyle || {}}
          className={this.props.className}
          arrowClass={this.props.arrowClass}
        >
          {this.props.children}
        </PopoverContent>
      </Overlay>
    )
  }
}

export default Popover
